import styled from "styled-components";

export const Dots = styled.span`
  &::after {
    display: inline-flex;
    width: fit-content;
    animation: ellipsis 1.25s infinite;
    content: ".";
    text-align: left;
    margin-left: 5px;
    position: absolute;
  }
  @keyframes ellipsis {
    0% {
      content: ".";
    }
    33% {
      content: "..";
    }
    66% {
      content: "...";
    }
  }
`;
